import { faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import Style from './Menu.module.css'
const Menu = (props) => {
    const openMenu=()=>{
        props.setopen()
    }
    return (
        <div className={Style.menuHolder}>
            <h3>خوش آمدید</h3>
            <FontAwesomeIcon icon={faBars} onClick={openMenu}/>
            
        </div>
    )
}

export default Menu
